import { render, staticRenderFns } from "./AuthorizationsVisualizePage.vue?vue&type=template&id=71f1b614&scoped=true&"
import script from "./AuthorizationsVisualizePage.vue?vue&type=script&lang=js&"
export * from "./AuthorizationsVisualizePage.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationsVisualizePage.vue?vue&type=style&index=0&id=71f1b614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f1b614",
  null
  
)

export default component.exports